module.exports = __webpack_public_path__ + "img/vaccination.0f535181.svg";